import { call, put, takeEvery } from 'redux-saga/effects'
import { AsyncAction } from 'src/utils/reduxUtils'
import { StitchFetchToken } from 'src/constants/actionTypes'
import { ApiService, callContractorPortalSecureApi } from '../api/callApi'
import { Endpoints } from 'src/constants/endpoints'
import { captureSentryError } from 'src/utils/sentry'

interface StitchFetchTokenRequest {
  token: string
}

function* onStitchFetchToken(action: AsyncAction<StitchFetchTokenRequest>) {
  try {
    const { token } = action.payload

    const { payload }: { payload: { token: string } } = yield call(
      callContractorPortalSecureApi,
      Endpoints.StitchFetchToken,
      {
        apiService: ApiService.Paraworks,
        query: { token },
      },
    )

    yield put(StitchFetchToken.success())

    if (action.next) {
      action.next(null, payload)
    }
  } catch (err: any) {
    captureSentryError(err, {
      message: '[saga.contractorPortal.onStitchFetchToken] error',
    })

    const errorMessage = err?.payload?.message || 'Failed to fetch stitch token'

    yield put(StitchFetchToken.failed(err))

    if (action.next) {
      action.next(errorMessage)
    }
  }
}

export function* contractorPortalStitchSaga() {
  yield takeEvery(StitchFetchToken.type.REQUEST, onStitchFetchToken)
}
